import { DefaultTheme } from "styled-components";
import bambinoLogo from "./logo.png";

export const bambinoTheme: DefaultTheme = {
  title: "bambino",

  colors: {
    primary: "#7967AB",
    secondary: "#3987C8",
    chatMessage: "#B3CE4F",
    header: "#F4E051",
    footer: "#7967AB",
    background: "#B3CE4F",
  },

  images: {
    logo: bambinoLogo,
    background: "",
  },
};
